
import RecoveryConvert from "../../../assets/duotone/RecoveryConvert.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RecoveryConvertIcon({ className, dataTestid = "RecoveryConvertIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RecoveryConvert data-testid={dataTestid} className={classes} {...rest} />
  );
}
